module.exports = __webpack_public_path__ + "img/sunnyncloudy.af40f0ce.svg";